export default API => ({
    // 查询等级list
    findListBySaasId(id) {
          return API({
            url: `/order/v1/goodsLevel/findListBySaasId` ,
          });
      },
      // 东堃定制
      saveUserAccess() {
        return API({
          url: `/saas/v1/dongkun/saveUserAccess` ,
          method:'post'
        });
      },
      // 查看用户是否同意协议
      viewUserAccess() {
        return API({
          url: `/saas/v1/dongkun/viewUserAccess` ,
        });
      },
  })